<ui-modal [modalTitle]="type === 'task' ? 'Add Task Time Entry' : 'Add Travel Entry'" size="md">

	<div *ngIf="userId || task || workOrder" class="conflict-list">
		<div *ngIf="hasConflict" class="text-primary mb-2 mt-nc"><i class="wq wq-info ml-2 mr-1"></i> There are time conflicts</div>
		<ui-form labelWidth="5rem">
			<div class="d-flex align-items-center mb-2">
				<ui-form-control label="Date" class="mr-5">
					<p-calendar [(ngModel)]="editdate" (ngModelChange)="onDateChange()" [maxDate]="today" [ngModelOptions]="{ standalone: true }" [dateFormat]="app.calendarDateFormat" [showTime]="false" inputStyleClass="form-control w-6r" appendTo="body"></p-calendar>
				</ui-form-control>

				<ui-form-control label="Task" class="w-100" *ngIf="!taskselected && type === 'task'">
					<div class="d-flex">
						<div class="form-control bg-lightergrey h-auto">
							<ng-container *ngIf="task">
								<div class="text-bold text-lines lines-1" uiEllipsisTooltip>{{task.name}}</div>
								<div class="text-small">Job: {{task.work_order_no}}</div>
							</ng-container>
							<div *ngIf="!task" class="text-secondary">No task selected.</div>
						</div>
						<button type="button" class="btn btn-outline-secondary px-2 ml-1" (click)="editSelectTask()" ngbTooltip="Select task"><i class="wq wq-search"></i></button>
						<button *ngIf="task" type="button" class="btn btn-outline-secondary px-2 ml-1" (click)="removeTask()" ngbTooltip="Remove task"><i class="wq wq-close"></i></button>
					</div>
				</ui-form-control>
				<ui-form-control label="Job" class="w-100" *ngIf="type === 'travel'">
					<div class="d-flex">
						<div class="form-control bg-lightergrey h-auto">
							<ng-container *ngIf="workOrder">
								<div class="text-bold text-lines lines-1" uiEllipsisTooltip>{{workOrder.name}}</div>
								<div class="text-small">{{workOrder.work_order_no}}</div>
							</ng-container>
							<div *ngIf="!workOrder" class="text-secondary">No job selected.</div>
						</div>
						<button type="button" class="btn btn-outline-secondary px-2 ml-1" (click)="editSelectWorkOrder()" ngbTooltip="Select job"><i class="wq wq-search"></i></button>
						<button *ngIf="workOrder" type="button" class="btn btn-outline-secondary px-2 ml-1" (click)="removeWorkOrder()" ngbTooltip="Remove job"><i class="wq wq-close"></i></button>
					</div>
				</ui-form-control>
				<ui-form-control label="User" *ngIf="!userselected">
					<select class="custom-select" [(ngModel)]="userId" placeholder="User" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onUserChange()">
						<option *ngFor="let u of userList" [ngValue]="u.id">{{u.name}}</option>
					</select>
				</ui-form-control>
			</div>

			<div class="d-flex item">
				<ui-form-control label="Start Time" class="mr-5">
					<p-calendar [(ngModel)]="start_datetime" [ngModelOptions]="{ standalone: true }" [timeOnly]="true" [hourFormat]="app.calendarHourFormat" [inputStyleClass]="hasConflict ? 'form-control w-6r conflict' : 'form-control w-6r'" appendTo="body"></p-calendar>
				</ui-form-control>
				<ui-form-control label="End Time">
					<p-calendar [(ngModel)]="end_datetime" [ngModelOptions]="{ standalone: true }" [timeOnly]="true" [hourFormat]="app.calendarHourFormat" [inputStyleClass]="hasConflict ? 'form-control w-6r conflict' : 'form-control w-6r'" appendTo="body"></p-calendar>
				</ui-form-control>
				<span *ngIf="hasConflict" class="ml-3 mt-2 text-center text-primary text-uppercase text-bold">{{conflictMessage(list[list.length - 1])}}</span>
			</div>
		</ui-form>
	</div>
	<div *ngIf="list">
		<hr>
		<div *ngIf="list.length" class="conflict-list" style="max-height: 525px; overflow: auto;">
			<ui-form>
				<ng-container *ngFor="let entry of list">
					<div *ngIf="entry.id !== 'new'" class="border p-2 mr-2 border-2 mb-4">
						<div class="mb-1 text-danger text-bold text-large">{{entry.project_description}}</div>
						<div class="d-flex align-items-center">
							<div class="ml-2">
								<div class="text-secondary">Job: {{entry.work_order_no}}</div>
								<div class="text-bold" *ngIf="entry.type === 'travel'">
									<i class="wq wq-truck-fill text-info mx-1"></i>Travel
								</div>
								<div *ngIf="entry.type ==='task'">
									<span class="text-lines lines-1 text-bold" style="max-width: 18rem;" uiEllipsisTooltip>Task: {{entry.task_name}}</span>
								</div>
								<div *ngIf="entry.needs_approval">
									<span class="text-info text-small mt-1">
										Approval Request:
										{{entry.edited_start_datetime | mySQLDateToISO | localizedDate:'shortTime'}} -
										{{entry.edited_end_datetime | mySQLDateToISO | localizedDate:'shortTime'}}
									</span>
								</div>
							</div>
							<div class="flex-weight-1"></div>
							<div class="mr-4">
								<div>
									<div class="d-flex align-items-center my-n2 item">
										<ui-form-control>
											<p-calendar disabled [(ngModel)]="entry.start_datetime" (ngModelChange)="validateConflicts()" [ngModelOptions]="{ standalone: true }" [timeOnly]="true" [hourFormat]="app.calendarHourFormat" [inputStyleClass]="entry.isConflict ? 'form-control w-6r conflict' : 'form-control w-6r'" appendTo="body"></p-calendar>
										</ui-form-control>
										<span><i class="wq wq-arrow-alt-right mx-2" [ngClass]="{'text-primary': entry.isConflict}"></i></span>
										<ui-form-control>
											<p-calendar disabled [(ngModel)]="entry.end_datetime" (ngModelChange)="validateConflicts()" [ngModelOptions]="{ standalone: true }" [timeOnly]="true" [hourFormat]="app.calendarHourFormat" [inputStyleClass]="entry.isConflict ? 'form-control w-6r conflict' : 'form-control w-6r'" appendTo="body"></p-calendar>
										</ui-form-control>
									</div>
									<div *ngIf="entry.isConflict" class="mt-n2 text-center text-primary text-uppercase text-bold">{{conflictMessage(entry)}}</div>
								</div>
							</div>
						</div>
						<ng-container *ngIf="entry.breaks && entry.breaks.length">
							<hr class="mx-2">
							<div class="ml-2">
								<div class="text-warning mb-1"><i class="wq wq-coffee mr-1"></i>Breaks</div>
								<div *ngFor="let break of entry.breaks; let i = index;" class="d-flex align-items-center">
									<div class="d-flex align-items-center mt-n2">
										<div>
											<div class="text-bold">Break {{ i + 1 }}</div>
											<div>
												<span *ngIf="break.needs_approval" class="text-info text-small mt-1">
													Approval Request:
													{{break.edited_start_datetime | mySQLDateToISO | localizedDate:'shortTime'}} -
													{{break.edited_end_datetime | mySQLDateToISO | localizedDate:'shortTime'}}
												</span>
											</div>
										</div>
									</div>
									<div class="flex-weight-1"></div>
									<div class="d-flex align-items-center mr-4">
										<div class="text-secondary mr-2 text-small">{{calculateTimeDifference(break.start_datetime, break.end_datetime) || 0 | hours}}</div>
										<div>
											<div class="d-flex align-items-center my-n2 item">
												<ui-form-control>
													<p-calendar disabled [(ngModel)]="break.start_datetime" (ngModelChange)="validateConflicts()" [ngModelOptions]="{ standalone: true }" [timeOnly]="true" [hourFormat]="app.calendarHourFormat" [inputStyleClass]="break.isConflict ? 'form-control w-6r conflict' : 'form-control w-6r'" appendTo="body"></p-calendar>
												</ui-form-control>
												<span><i class="wq wq-arrow-alt-right mx-2"></i></span>
												<ui-form-control>
													<p-calendar disabled [(ngModel)]="break.end_datetime" (ngModelChange)="validateConflicts()" [ngModelOptions]="{ standalone: true }" [timeOnly]="true" [hourFormat]="app.calendarHourFormat" [inputStyleClass]="break.isConflict ? 'form-control w-6r conflict' : 'form-control w-6r'" appendTo="body"></p-calendar>
												</ui-form-control>
											</div>
											<div *ngIf="break.isConflict" class="mt-n2 text-center text-primary text-uppercase text-bold">{{conflictMessage(break)}}</div>
										</div>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
				</ng-container>

			</ui-form>
		</div>

		<div *ngIf="!list?.length" class="w-100 h-100 d-flex align-items-center justify-content-center text-secondary">
			<p>No timesheet entries for this day</p>
		</div>
	</div>

	<button class="btn btn-secondary" (click)="modal.close()" ui-modal-footer>Cancel</button>
	<button class="btn btn-primary" (click)="add()" ui-modal-footer>Add</button>

</ui-modal>

<modal-select-task (close)="editSelectTaskModalClosed($event)"></modal-select-task>
<modal-select-work-order (close)="editSelectWorkOrderModalClosed($event)"></modal-select-work-order>
